import { useState } from "react";

import {
  Popper,
  Paper,
  Typography,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { MdHelpOutline } from "react-icons/md";

import { useToggle } from "../../CustomHooks/useToggle";
import { useStyles } from "../../Styles/styles";

const TooltipIcon = ({ hoverText = "", text = "" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showPopper, togglePopper] = useToggle(false);

  const classes = useStyles();

  const handlePopperClick = e => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
    togglePopper();
  };

  return (
    <>
      <Tooltip title={hoverText}>
        <IconButton
          style={{
            ...{
              padding: "0px",
              width: "30px",
              height: "30px",
              fontSize: "20px",
            },
          }}
          onClick={handlePopperClick}
        >
          <MdHelpOutline />
        </IconButton>
      </Tooltip>
      <Popper
        placement="right"
        open={showPopper}
        disablePortal={true}
        anchorEl={anchorEl}
        modifiers={{
          flip: {
            enabled: false,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: "viewport",
          },
        }}
      >
        <Paper
          style={{
            padding: 10,
            border: "1px solid black",
            boxShadow: "1px 1px 1px grey",
            zIndex: 1300,
          }}
        >
          <Typography>
            <CloseIcon
              style={{ float: "right" }}
              onClick={handlePopperClick}
              className={classes.hover}
            />
            {text}
          </Typography>
        </Paper>
      </Popper>
    </>
  );
};

export default TooltipIcon;
